import { render, staticRenderFns } from "./RevenueCategoryList.vue?vue&type=template&id=b3633d7a&scoped=true&"
import script from "./RevenueCategoryList.vue?vue&type=script&lang=ts&"
export * from "./RevenueCategoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3633d7a",
  null
  
)

export default component.exports